/** The user role */
export enum UserRole {
  Customer = 'CUSTOMER',
  Mechanic = 'MECHANIC',
  Admin = 'ADMIN',
}
